const size = {
    sp: '320px',
    pc: '767px'
}

export const DeviceSize = {
  sp: `(min-width: ${size.sp})`,
  pc: `(min-width: ${size.pc})`
}